import { render, staticRenderFns } from "./NewUserSetPassword.vue?vue&type=template&id=7c32fcf8&"
import script from "./NewUserSetPassword.vue?vue&type=script&lang=js&"
export * from "./NewUserSetPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewUserSetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports